import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Navbar from './components/Navbar';
import Home from './components/Home';
import About from './components/About';
import Courses from './components/courses';


import ContactUs from './components/ContactUS';
import Pricings from './components/Pricings';
import Footer from './components/Footer';

// import Crausel from './components/Crausel';
import Coursedescription from './components/Coursedescription';
import Frequently from './Frequently';
import Blogs from './components/Blogs';
import TajweedCourse from './components/TajweedCourse';
import HifzCourse from './components/HifzCourse';
import QuranReadingCourse from './components/QuranReadingCourse';


// import CourseFirst from './components/coursefirst';




const App = () => {
    return (
        <Router>
         <Navbar/>
         {/* <Crausel/> */}
       
       
            <div className="container mt-3">
                <Routes>
                    <Route path="/" element={<Home/>} />
        
                    <Route path="/about" element={<About/>} />
                    <Route path="/courses" element={<Courses/>} />
                    <Route path="/Course Description" element={<Coursedescription/>} />
                    {/* <Route path="/CourseFirst" element={<CourseFirst/>} /> */}
                    <Route path="/Course Description" element={<Coursedescription/>} />
                    <Route path="/Coursedescription" element={<Coursedescription/>} />
                 
                    <Route path="/FAQ" element={<Frequently/>} />
                    <Route path="/pricing" element={<Pricings/>} />
                    <Route path="/Blogs" element={<Blogs/>} />
                    <Route path="/tajweed-course" element={<TajweedCourse/>} />
                <Route path="/hifz-course" element={<HifzCourse/>} />
                <Route path="/quran-reading-course" element={<QuranReadingCourse/>} />
                  
                    
                    <Route path="/contact-us" element={<ContactUs/>} />
                    
                </Routes>
            </div>
            <Footer/>
          
        </Router>
    );
};

export default App;
